import theme from '@vromo/ui/components/theme';

export default {
    linkText: {
        textDecoration: 'underline'
    },
    helpText: {
        paddingBottom: 12,
        color: theme.darkText
    }
};
